



















































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import BirthdaysBirthdayDetails from "./BirthdaysBirthdayDetails.vue";

import BirthdayBookingInfoJson from "../../shared/BirthdayBookingInfoJson";
import BirthdayBookingJson from "../../shared/BirthdayBookingJson";
import CustomerJson from "../../shared/CustomerJson";

import UserJson from "../../shared/UserJson";

import { BirthdayBookingStatus } from "../../shared/BirthdayBookingStatus";
import { Gender } from "../../shared/Gender";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "BirthdaysOverview",
  components: {
    Loading,
    TableView,
    BirthdaysBirthdayDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      allUsers: null as UserJson[] | null,
      birthdayInfo: null as BirthdayBookingInfoJson | null,
      attentionalBirthdayBookings: null as BirthdayBookingJson[] | null,
      attentionalBirthdayBookingsMoreAvailable: null as boolean | null,
      todayBirthdayBookings: null as BirthdayBookingJson[] | null,
      todayBirthdayBookingsMoreAvailable: null as boolean | null,
      selectedBirthdayId: null as number | null,
      selectedBirthday: null as BirthdayBookingJson | null,
      detailsMode: "read",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadAttentionalBirthdays();
      this.loadTodayBirthdays();
      this.loadBirthdayInfo();
      this.loadAllUsers();
    },

    async reloadSelectedBirthday() {
      this.selectedBirthday = null;
      this.toggleDetails();
      if (this.selectedBirthdayId != null) {
        try {
          this.selectedBirthday = await this.restClient.getBirthdayBooking(this.selectedBirthdayId);
          this.openDetails(this.selectedBirthday, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    // START load birthdays

    async loadAttentionalBirthdays(loadMore: null = null) {
      var states: BirthdayBookingStatus[] = [
        BirthdayBookingStatus.requestedStaffRequired,
        BirthdayBookingStatus.requestedNoStaffAvailable,
        BirthdayBookingStatus.requestedPendingConfirmation,
        BirthdayBookingStatus.cancellationPending,
      ];

      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.attentionalBirthdayBookings != null) {
        this.attentionalBirthdayBookingsMoreAvailable = null;

        skipAmount = this.attentionalBirthdayBookings.length;
      } else {
        this.attentionalBirthdayBookings = null;
      }

      //final load
      if (this.restClient != null) {
        try {
          let birthdays = await this.restClient.getBirthdayBookings(states, null, null, null, null, null, skipAmount);

          if (loadMore && this.attentionalBirthdayBookings != null) {
            this.attentionalBirthdayBookings = this.attentionalBirthdayBookings.concat(birthdays.birthdayBookings);
          } else {
            this.attentionalBirthdayBookings = birthdays.birthdayBookings;
          }

          this.attentionalBirthdayBookingsMoreAvailable = birthdays.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadTodayBirthdays(loadMore: null = null) {
      let today = new Date();

      var skipAmount = null as number | null;
      var afterDateTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
      var beforeDateTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 99);

      if (loadMore && this.todayBirthdayBookings != null) {
        this.todayBirthdayBookingsMoreAvailable = null;

        skipAmount = this.todayBirthdayBookings.length;
      } else {
        this.todayBirthdayBookings = null;
      }

      if (this.restClient != null) {
        try {
          let birthdays = await this.restClient.getBirthdayBookings(
            null,
            null,
            afterDateTime,
            beforeDateTime,
            null,
            null,
            skipAmount
          );

          if (loadMore && this.todayBirthdayBookings != null) {
            this.todayBirthdayBookings = this.todayBirthdayBookings.concat(birthdays.birthdayBookings);
          } else {
            this.todayBirthdayBookings = birthdays.birthdayBookings;
          }

          this.todayBirthdayBookingsMoreAvailable = birthdays.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    // END load birthdays

    async loadBirthdayInfo() {
      try {
        let rc = RestClient;
        this.birthdayInfo = await rc.getBirthdayBookingInfo();
      } catch (e) {
        alert(e.message);
      }
    },

    //todo: viell. in Zukunft nur die einzelnen User laden
    async loadAllUsers() {
      try {
        this.allUsers = await this.restClient.getUsers();
      } catch (e) {
        alert(e.message);
      }
    },

    getStaffFullName(staffId: number | null) {
      if (staffId != null) {
        if (this.allUsers != null) {
          let staff = this.allUsers.find((user) => user.ID == staffId);

          return staff?.firstName + " " + staff?.lastName;
        }
      } else {
        return "ohne Betreuer";
      }
    },

    openDetails(item: BirthdayBookingJson | null, mode: string) {
      if (item != null) {
        //this.selectedBirthday = JSON.parse(JSON.stringify(item))
        this.selectedBirthdayId = item.ID;
      } else {
        this.selectedBirthdayId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    birthdayColumns: function (): TableViewColumnDefinitions<BirthdayBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) =>
            i.customer.guardianLastName != ""
              ? i.customer.guardianLastName + ", " + i.customer.guardianFirstName
              : "--",
        },
        {
          th: "Name (Kind)",
          td: (i) =>
            i.customer.childLastName != "" ? i.customer.childLastName + ", " + i.customer.childFirstName : "--",
        },
        {
          th: "Datum",
          td: (i) => DateFormatter.formatDateWeekday(new Date(i.beginDateTime)),
          sortBy: (i) => i.beginDateTime,
        },
        {
          th: "Uhrzeit",
          td: (i) =>
            DateFormatter.formatTime(new Date(i.beginDateTime)) +
            " – " +
            DateFormatter.formatTime(new Date(i.endDateTime)),
        },
        {
          th: "Programm",
          td: (i) => i.programTitle,
        },
        {
          th: "Ort",
          td: (i) => (i.location != "" ? i.location : "--"),
        },
        {
          th: "Betreuer:in",
          td: (i) => vue.getStaffFullName(i.staffId),
        },
        {
          th: "Status",
          td: (i) => vue.BirthdayBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<BirthdayBookingJson>[];
    },
  },
});
